import { useCallback } from "react";
import { useAuthFetch } from "../utils/useAuthFetch";
import {
  EnvFeatureFlag,
  EnvFeatureFlagWrite,
  MetalMindAdminUser,
} from "../views/metalmindAdmin/types";

export const useListMetalMindAdminFeatureFlags = () => {
  const authFetch = useAuthFetch();

  return useCallback(async (): Promise<EnvFeatureFlag[]> => {
    return (await authFetch(
      "/api/admin/metalmind/feature-flags",
      "list MetalMind Admin feature flags",
    )) as EnvFeatureFlag[];
  }, [authFetch]);
};

export const useSetMetalMindAdminFeatureFlag = () => {
  const authFetch = useAuthFetch();

  return useCallback(
    async (
      flagKey: string,
      body: EnvFeatureFlagWrite,
    ): Promise<EnvFeatureFlag> => {
      return (await authFetch(
        `/api/admin/metalmind/feature-flags/${encodeURIComponent(flagKey)}`,
        "set MetalMind Admin feature flag",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        },
      )) as EnvFeatureFlag;
    },
    [authFetch],
  );
};

export const useDeleteMetalMindAdminFeatureFlag = () => {
  const authFetch = useAuthFetch();

  return useCallback(
    async (flagKey: string): Promise<void> => {
      await authFetch(
        `/api/admin/metalmind/feature-flags/${encodeURIComponent(flagKey)}`,
        "delete MetalMind Admin feature flag override",
        {
          method: "DELETE",
        },
      );
    },
    [authFetch],
  );
};

export const useListMetalMindAdminUsers = () => {
  const authFetch = useAuthFetch();

  return useCallback(async (): Promise<MetalMindAdminUser[]> => {
    return (await authFetch(
      "/api/admin/metalmind/users",
      "list MetalMind Admin users",
    )) as MetalMindAdminUser[];
  }, [authFetch]);
};

export const useGrantMetalMindAdminUser = () => {
  const authFetch = useAuthFetch();

  return useCallback(
    async (userId: string): Promise<MetalMindAdminUser> => {
      return (await authFetch(
        `/api/admin/metalmind/users/${encodeURIComponent(userId)}/grant`,
        "grant MetalMind Admin access",
        {
          method: "PUT",
        },
      )) as MetalMindAdminUser;
    },
    [authFetch],
  );
};

export const useRevokeMetalMindAdminUser = () => {
  const authFetch = useAuthFetch();

  return useCallback(
    async (userId: string): Promise<MetalMindAdminUser> => {
      return (await authFetch(
        `/api/admin/metalmind/users/${encodeURIComponent(userId)}/grant`,
        "revoke MetalMind Admin access",
        {
          method: "DELETE",
        },
      )) as MetalMindAdminUser;
    },
    [authFetch],
  );
};
